import { loadMock } from "../utils/mock";

export interface Banner {
  code: string;
  image: string;
}

export interface BannerListApiResponse {
  status: number;
  system: string;
  message: string;
  data: Banner[];
}

export const getBannerList = async (): Promise<BannerListApiResponse> => {
  return loadMock<BannerListApiResponse>("banner.json");
};
